export default __webpack_public_path__ + "static/imgSSM3-2cb3151ddda07e653be32197b53b717d.png";